import { getPluralRoleTitle } from "@src/utils/data/roles.utils";
import { SelectInputData } from "../../../components/deprecated/SelectInputField/SelectInputField";

import { ArrayUtilities } from "../../../utils/arrayUtilities";
import { StringUtilities } from "../../../utils/stringUtilities";
import { LocalData } from "../General/LocalData";
import { PropertyData } from "../Property/PropertyData";
import { UnitData } from "../Property/Units/UnitData";
import { Role } from "../User/Role";
import { t } from "i18next";

export interface DeviationVisibility {
  landlords: boolean;
  tenants: boolean;
  allTenants: boolean;
}
export type DeviationReportVisibilityType = "onlyLandlords" | "allTenants" | "tenants";

export class DeviationVisibilityHelper {
  static getStandard(property: PropertyData | undefined): DeviationVisibility {
    let member = property?.members.getData(LocalData.currentUser.id);
    return {
      landlords: true,
      allTenants: false,
      tenants: ArrayUtilities.areArraysEqual(member?.roles ?? [], [Role.RENTER]),
    };
  }

  static getOptions(units: UnitData[]): SelectInputData[] {
    const options: DeviationReportVisibilityType[] = ["onlyLandlords", "allTenants", "tenants"];
    return options.map((type) => new SelectInputData(type, this.getOptionLabel(units, type)));
  }

  static getOptionForVisibility(visibility: DeviationVisibility): SelectInputData {
    if (visibility?.allTenants) return new SelectInputData("allTenants", this.getOptionLabel([], "allTenants"));
    else if (visibility?.tenants) return new SelectInputData("tenants", this.getOptionLabel([], "tenants"));
    else if (visibility?.landlords) return new SelectInputData("onlyLandlords", this.getOptionLabel([], "onlyLandlords"));
    return new SelectInputData("", "");
  }
  static getVisibilityForType(visibility: string): DeviationVisibility {
    if (visibility === "allTenants") return { landlords: true, allTenants: true, tenants: false };
    else if (visibility === "tenants") return { landlords: true, allTenants: false, tenants: true };
    else if (visibility === "onlyLandlords") return { landlords: true, allTenants: false, tenants: false };
    return { landlords: true, allTenants: false, tenants: false };
  }

  static getLabelForVisbility(units: UnitData[], visibility?: DeviationVisibility): string {
    if (visibility?.allTenants) return this.getOptionLabel(units, "allTenants");
    else if (visibility?.tenants) return this.getOptionLabel(units, "tenants");
    else if (visibility?.landlords) return this.getOptionLabel(units, "onlyLandlords");
    return t("main.none");
  }

  static getOptionLabel(units: UnitData[], type: DeviationReportVisibilityType): string {
    if (type === "onlyLandlords") {
      let word = this.getStringWithName(t("main.onlyLandlordsOnProperty"));
      return word;
    } else if (type === "allTenants") {
      let word = this.getStringWithName(t("main.landlordsAndAllTenants"));
      return word;
    } else if (type === "tenants")
      return (
        this.getStringWithName(t("main.landlordsAndTenantsOn")) +
        " " +
        (units.length > 0
          ? StringUtilities.capitalize(StringUtilities.createString(units.map((unit) => unit.name)).toLowerCase())
          : t("main.specifiedUnits")
        ).toLowerCase()
      );
    else return "";
  }

  static getStringWithName(text: string): string {
    return StringUtilities.capitalize(
      StringUtilities.replaceAll(
        StringUtilities.replaceAll(text, "{{landlords}}", getPluralRoleTitle(Role.LANDLORD.id, undefined).toLowerCase()),
        "{{tenants}}",
        getPluralRoleTitle(Role.RENTER.id, undefined).toLowerCase()
      ).toLowerCase()
    );
  }
}
